export enum SuggestPriceFormNames {
	price = 'price',
	currency = 'currency',
	rate = 'rate',
}
